import React from "react";
import "./seat-map.css";
import _ from "lodash";

const SeatIcon = (props) => {
  const {
    fill = "#FFF",
    seat_number,
    stroke = "#B8B8B8",
    textColor = " #000",
    width = 45,
    height = 45,
    onClick,
    selectedSeat,
    maxSeat,
  } = props;

  const isSelectable =
    fill === "#fc346a" || fill === "#000" || (fill === "#a0a0a0" && maxSeat);
  //maxSeat in the create booking screen => not allow clicking in create booking screen with disabled seat
  // || fill === "#a0a0a0"

  return (
    <div
      className="seat-div"
      style={{
        cursor: isSelectable ? "not-allowed" : "pointer",
      }}
    >
      <svg
        width={width}
        height={height}
        style={{
          pointerEvents:
            isSelectable ||
            (selectedSeat?.length >= maxSeat &&
              !_.includes(selectedSeat, seat_number))
              ? "none"
              : "auto",
        }}
        viewBox="0 0 40 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="selected"
        onClick={onClick}
      >
        <rect
          x="8.75"
          y="2.75"
          width="22.5"
          height="26.5"
          rx="2.25"
          fill={fill}
          stroke={stroke}
          stroke-width="1.5"
          stroke-linejoin="round"
        ></rect>
        <rect
          x="10.25"
          y="11.75"
          width="14.5"
          height="5.5"
          rx="2.25"
          transform="rotate(90 10.25 11.75)"
          fill={fill}
          stroke={stroke}
          stroke-width="1.5"
          stroke-linejoin="round"
        ></rect>
        <rect
          x="35.25"
          y="11.75"
          width="14.5"
          height="5.5"
          rx="2.25"
          transform="rotate(90 35.25 11.75)"
          fill={fill}
          stroke={stroke}
          stroke-width="1.5"
          stroke-linejoin="round"
        ></rect>
        <rect
          x="8.75"
          y="22.75"
          width="22.5"
          height="6.5"
          rx="2.25"
          fill={fill}
          stroke={stroke}
          stroke-width="1.5"
          stroke-linejoin="round"
        ></rect>
        <text
          width="20"
          height="20"
          x="20"
          y="18"
          fill={textColor}
          font-size="10"
          text-anchor="middle"
        >
          {seat_number}
        </text>
      </svg>
    </div>
  );
};

export default SeatIcon;
